import moment from 'moment';

/**
 * Builds the query object for GET /qms from vue-router query.
 * - Always includes page & page_size (defaults 1 & 30).
 * - When searchkey + search are used (e.g. Employee Mobile filter), does not inject default dates.
 * - Otherwise applies default last-30-days range when dates are absent.
 */
export function normalizeQmsListQuery(routeQuery = {}) {
  const q = { ...routeQuery };

  const searchVal = q.search != null ? String(q.search).trim() : '';
  const hasSearchFilter = q.searchkey != null && searchVal !== '';

  if (q.page === undefined || q.page === null || q.page === '') {
    q.page = 1;
  } else {
    const p = Number(q.page);
    q.page = Number.isFinite(p) && p > 0 ? p : 1;
  }

  if (q.page_size === undefined || q.page_size === null || q.page_size === '') {
    q.page_size = 30;
  } else {
    const ps = Number(q.page_size);
    q.page_size = Number.isFinite(ps) && ps > 0 ? ps : 30;
  }

  const hasExplicitDates = Boolean(q.startdate && q.enddate);
  if (!hasExplicitDates && !hasSearchFilter) {
    if (!q.startdate) {
      q.startdate = moment().subtract(1, 'months').format('YYYY-MM-DD');
    }
    if (!q.enddate) {
      q.enddate = moment().format('YYYY-MM-DD');
    }
  }

  return q;
}

export default normalizeQmsListQuery;
